'use client';

import { useEffect } from 'react';

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Include error.digest so this client-visible error correlates with the
    // matching server-side log entry (Next tags both with the same digest).
    const label = error.digest ? `${error.message} [digest:${error.digest}]` : error.message;
    window._paq?.push(['trackEvent', 'Error', 'PageError', label]);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <h1 className="font-heading text-4xl font-bold text-text-primary">Something went wrong</h1>
      <p className="mt-2 text-lg text-text-secondary">An unexpected error occurred.</p>
      <button
        onClick={reset}
        className="mt-6 rounded-lg bg-brand px-5 py-2.5 text-sm font-medium text-text-on-brand transition-colors hover:bg-brand/90"
      >
        Try again
      </button>
    </div>
  );
}
